<template>
  <div id="app" class="main-body">
    <app-header></app-header>
    <app-status-alert></app-status-alert>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import appHeader from './components/Header';
import appFooter from './components/Footer';
import appStatusAlert from './components/StatusAlert';

export default {
  name: 'App',
  components: {
    'app-header': appHeader,
    'app-footer': appFooter,
    'app-status-alert': appStatusAlert,
  },
  created() {
    /* Reset groups on initial load. This is to reset the groupsFetched flag as this is needed for integration tests. */
    this.$store.commit('clearGroups');
    if (this.$store.getters.isDevBackend) {
      const meta = document.createElement('meta');
      meta.name = 'insight-app-sec-validation';
      meta.content = 'ef961460-bc45-44fd-88ee-7f36bb9e62f4';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue